import SaleLot from "./SaleLot";

export default SaleLot;
